import "./IndexLife.css";
import Familylife from "../SmcLife/Images/family-term-life.jpg";
import hdfc from "../SmcLife/Images/HDFC_Life_Logo.png";
import TataAia from "../SmcLife/Images/TATA-AIA-Logo.png";
import TaxBenepic from "../SmcLife/Images/Group2265.svg";
import "./HouseWifeTerm.css";

const LifeTerm = () => {
    return (
        <div className="col-lg-7">
            <h4 className="Index-Plan">
                Get an <span className="textcolor"> Ideal </span>Life
                Insurance Plan for Lasting your Family Security
            </h4>
            <p className="Index-Plan-Cont">
                We suggest best plans as per your life stage
            </p>
            <div className="Added_PicTaxBenefitBox">
                <div className="row">
                    <div className="col-md-6">
                        <div className="Family_lifesec">
                            <div>
                                <img
                                    src={Familylife}
                                    className="imgtop m-auto "
                                    alt="Life Plan Image"
                                />
                            </div>
                            <div className="TaxBenefits">
                                <img src={TaxBenepic} alt="Get tax" />
                                <div className="GetLifeCNT">
                                    <p>Get tax benefits up to</p>
                                    <h2>₹ 1.5 Lakh</h2>
                                    <p>under section 80C</p>
                                </div>
                            </div>
                        </div>

                        {/*<div className="review_box2">
                                                    <a
                                                        className="review_box"
                                                        href="/customer-reviews"
                                                        target="_blank"
                                                    >
                                                        <div className="indem-rate">
                                                            <img src={google} className="indem_googl" />
                                                            <img src={rattings} className="indem_star" />
                                                        </div>
                                                        <p>Highly rated insurance website</p>
                                                    </a>
                                                </div>
*/}
                    </div>

                    <div className="col-md-6 p-0 brands-logo-term-conatiner">
                        <ul className="partners_img alliances_logo brands-logo-term">
                            <li className="partner_logo partner_logo1 ">
                                <span>
                                    <img
                                        src="https://www.smcinsurance.com/insurer%20logo/aegon.jpg"
                                        className="aegon_life"
                                        alt="aegon_life"
                                    />
                                </span>
                            </li>
                            <li className="partner_logo">
                                <span>
                                    <img src={hdfc} className="hdfc_life" alt="hdfc_life" />
                                </span>
                            </li>

                            <li className="partner_logo partner_logo1">
                                <span>
                                    <img src={TataAia} className="tata_aia" />
                                </span>
                            </li>

                            <li className="Add_more">
                                <span>+many more</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default LifeTerm;
